<template>
	<fragment>
		<span class="ico_bbs ico_picture" v-if="hasImage">사진첨부</span>
		<span class="ico_bbs ico_video" v-if="hasVideo">동영상첨부</span>
		<span class="ico_bbs ico_file" v-if="hasFile">파일첨부</span>
		<span class="ico_bbs ico_vote" v-if="hasPoll">투표글</span>
		<span class="tag_item" v-if="isSafeTrade">안전거래</span>
		<span class="tag_item" v-if="isSold">판매완료</span>
		<span class="ico_bbs ico_new" v-if="isNew">새글</span>
	</fragment>
</template>

<script>
export default {
	props: {
		hasImage: Boolean,
		hasVideo: Boolean,
		hasFile: Boolean,
		hasPoll: Boolean,
		isSafeTrade: Boolean,
		isSold: Boolean,
		isNew: Boolean
	}
}
</script>
